// ESM-Huelle um lib/scripts/pos/CLS_CEANManager.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals
// modulweit deklarieren (nur ZUGEWIESENE Namen - nur-gelesene wie
// process/lp behalten bewusst ihren vorbestehenden ReferenceError).
var def4;
function CEANManager(mainBon) {
    this.Main = mainBon;
}

CEANManager.prototype.getProductFromEANCode = function (code) {
    /*privMan.enablePrivilege (privList);*/
    var EANManagerClass = this;
    var dfd = jQuery.Deferred();
    if (!code) {
        var text = POS.lang.getText("MESSAGES", "NO_EAN_CODE");
        POS.message.show(text, "warning", "OK");
        dfd.resolve(false);
        return;
        //return false;
    }

    var sql = "SELECT max(PROD_ID) as PROD_ID FROM PROD WHERE EAN = '" + code + "'";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        // max() liefert auch ohne Treffer EINE Zeile mit PROD_ID null -
        // ohne diese Pruefung lief addProd(null) in "PROD_ID = NaN" und die
        // Kasse startete neu (Testkasse 15.10.2026).
        if (!rows || rows.length == 0 || rows[0].PROD_ID == null) {
            //r.free();
            EANManagerClass.showNotFound("PRODUCT");
            dfd.resolve(false);
            return;
            //return false;
        }

        var prodId = rows[0].PROD_ID;
        //r.free();
        var parameters = Array(EANManagerClass.Main.id, prodId);

        // Herkunft der Eingabe. Der Zweig "scanner" gehoerte zum Funkscanner
        // (entfallen am 26.8.2026) - ohne ihn war barcodeRequested immer
        // falsch, also bleibt "screen".
        parameters[2] = "screen";

        EANManagerClass.Main.addProd(EANManagerClass, parameters, EANManagerClass.Main);

        EANManagerClass.Main.components.info.input.setFocus();
        EANManagerClass.Main.vacuumInfoValue(EANManagerClass.Main);
        dfd.resolve(true);
        //return true;
    });
    return dfd.promise();
}

CEANManager.prototype.printCustomerBarcode = function (barcodeNumber) {
    var EANManagerClass = this;
    var dfd = jQuery.Deferred();
    $.when(Printer.head()).done(function () {
        Printer.addLine("B", 1, false, 1);
        Printer.addBarcodeLine("AA", 2, 72, barcodeNumber, 1); // Documentation error!!! The right code number in the second group is always one unit less! (73->72)

        Printer.addLine("A", 1, false, 0);
        Printer.addElement(barcodeNumber.toString(), 20, 2, true, 0, 41);
        Printer.addLine("B", 1, false, 4);

        // date:
        var d = new Date();

        var dateTime = d.getDate() + "." + (d.getMonth() + 1) + "." +
            (d.getYear() + 1900);

        Printer.addLine("A", 1, false, 0);
        Printer.addElement(POS.lang.getText("LABELS", "DATE") + ":", 7, 0, false, 7, 19);
        Printer.addElement(dateTime, 20, 0, false, 20, 40);

        // shop:
        $.when(Trans.getShopName()).then(function (shopName) {
            Printer.addLine("A", 1, false, 0);
            Printer.addElement(POS.lang.getText("LABELS", "SHOP_NAME") + ":", 7, 0, false, 7, 19);
            Printer.addElement(shopName, 20, 0, false, 20, 40);

            // pos user
            $.when(Trans.getPOSUserName(EANManagerClass.Main.UID)).then(function (userName) {
                Printer.addLine("A", 1, false, 0);
                Printer.addElement(POS.lang.getText("LABELS", "EMPLOYEE_NAME") + ":", 7, 0, false, 7, 19);
                Printer.addElement(userName, 20, 0, false, 20, 40);

                // info note
                Printer.addLine("B", 1, false, 4);

                Printer.addLine("A", 1, false, 0);
                var text = POS.lang.getText("LABELS", "NEW_CUSTOMER_CARD_NOTE_1");
                Printer.addElement(text, 20, 2, true, 0, 41);
                Printer.addLine("A", 1, false, 0);
                text = POS.lang.getText("LABELS", "NEW_CUSTOMER_CARD_NOTE_2");
                Printer.addElement(text, 20, 2, true, 0, 41);

                Printer.print();
                dfd.resolve();
            });
        });
    });
    return dfd.promise();
}

CEANManager.prototype.getCustomerFromBarcode = function (code, mode) {
    var EANManagerClass = this;
    code = code.valueOf();
    $.when(Trans.getCustomerIdFromBarcode(code)).then(function (custId) {
        code = Number(code);
        if ((code > 1115000000000) && (code < 1120000000000)) {
            custId = code;
        }
        $.when(Trans.getCustomerData(custId)).then(function (custData) {
            var def = $.Deferred();
            /* if (!custData["firstName"] && !custData["surname"]) {
            var def4 = EANManagerClass.printCustomerBarcode(code);
            } else {*/
            def4 = 0;
            //}


            $.when(def4).done(function () {
                if (EANManagerClass.Main.cmpCopies && EANManagerClass.Main.cmpCopies.transmitted) {
                    EANManagerClass.Main.cmpCopies.components.inputField.input.properties.attributes.value = code;
                    EANManagerClass.Main.cmpCopies.components.inputField.input.reAttribute();
                    def.resolve();
                } else {
                    EANManagerClass.Main.BonManager.currentCustomerId = custId;
                    EANManagerClass.Main.BonManager["currentCustomerEAN"] = code;

                    if (EANManagerClass.Main.BonManager.currentBonId != 0) {
                        var def2 = EANManagerClass.Main.BonManager.redrawAll();
                    } else {
                        def2 = 0;
                    }
                    $.when(def2).done(function () {
                        EANManagerClass.Main.InfoIcons.highlightIcon("customer");

                        if (mode == 'wholecust') {
                            // war "Main.components..." - ein freies Main gibt es nicht (ReferenceError
                            // beim Scannen einer Grosskundenkarte, schon im Legacy).
                            EANManagerClass.Main.components.payment2.children[6 - EANManagerClass.Main.components.payment.childrenCount].setEnabled(true);

                        }
                        /*$.when(Trans.isObsoleteAddress(custId)).then(function (val) {
                        if (val) {
                        var ccust = new CCustomerAdmin();
                        ccust.doObsoleteAddress(custId);

                        }
                        def.resolve();
                        });*/
                        def.resolve();
                    });
                }

                $.when(def).done(function () {
                    EANManagerClass.Main.BonManager.comesFromId = true;
                    EANManagerClass.Main.BonManager.updateInstantRebate();
                });
            });

        });
    });
}

CEANManager.prototype.getButtonFromBarcode = function (code) {
    /*privMan.enablePrivilege (privList);*/
    var EANManagerClass = this;
    var sql = "SELECT BTN_ID, Text1, Text2 FROM BTN WHERE Parent_BTN_ID = 0 ORDER BY BTN_ID ASC";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        if (rows.length == 0) {
            //r.free();
            EANManagerClass.showNotFound("BUTTON");
            return;
        }

        var group = parseFloat(code[3] + code[4]);
        var page = parseFloat(code[5] + code[6]);
        var row = parseFloat(code[7] + code[8] + code[9]);
        var col = parseFloat(code[10] + code[11]);

        for (var i = 0; i < group; i++) {
            if (i < rows.length)
                try {
                    var parentButton = rows[i].BTN_ID;
                    var text1Top = rows[i].Text1;
                    var text2Top = rows[i].Text2;
                    var groupName = text1Top + " " + text2Top;
                } catch (e) {
                    //r.free();
                    EANManagerClass.showNotFound("BUTTON");
                    return;
                }
        }
        //if (i < rows.length)
        //r.moveNext();


        //r.free();

        sql = "SELECT PROD_ID, FreePrice, Text1 FROM BTN WHERE Parent_BTN_ID = " + parentButton +
            " AND Page = " + page + " AND Row = " + row + " AND Col = " + col;
        var def = $.Deferred();
        try {
            $.when(POS.SQLiteCon.execute(sql)).then(function (rows2) {
                def.resolve(rows2);
            },
                function (err) {
                def.reject();
                throw new Error();
            });

        } catch (e) {
            //r.free();
            EANManagerClass.showNotFound("BUTTON");
            return;
        }
        $.when(def).done(function (rows2) {
            //if (r.recordCount() != 1)
            if (rows2.length != 1) {
                //r.free();
                EANManagerClass.showNotFound("BUTTON");
                return;
            }

            var prodId = rows2[0].PROD_ID;
            var freePrice = rows2[0].FreePrice;
            var text1 = rows2[0].Text1;
            //r.free();

            var parameters = Array(EANManagerClass.Main.id, prodId);

            if (freePrice == "0") {
                parameters[2] = "screen";   // siehe oben: Funkscanner entfallen

                EANManagerClass.Main.addProd(EANManagerClass, parameters);
            } else {
                if (page == 1 && col == 4 && row == 10)
                    parameters[2] = groupName;
                else
                    parameters[2] = text1;


                EANManagerClass.Main.addProdWithPrice(EANManagerClass, parameters);
            }

            EANManagerClass.Main.components.info.input.setFocus();
            EANManagerClass.Main.vacuumInfoValue(EANManagerClass.Main);
        });
    });
}

CEANManager.prototype.getRebateFromBarcode = function (code) {
    var EANManagerClass = this;
    var BM = this.Main.BonManager;

    //Dirty "Lucky Day" Hack:
    if (code == "6660330330330") {
        BM.overridePriv = true;
        $.when(BM.grantRebAbsolute(10, true, null, "Lucky Number")).then(function () {
            $.when(BM.updateInstantRebate(true)).then(function () {
                var openSum = BM.getSumArray()[6];
                if (openSum == 0 && BM.currentBon.length > 0)
                    BM.closePayment(BM, null, false);
                return;
            });
        });
        return;
    }
    // ---
    /*if (BM.isPPCCharge()) {
    POS.message.show("Auf dieses Produkt gibt es keinen Rabatt", "warning", "OK");
    return;
    }*/

    // Code for super bons
    // $.when(Trans.checkIfSuperBon(this.Main.BonManager.currentCustomerId, code, BM.getSelectedItem(true))).then(function (superBonId, Name) {
    $.when(Trans.checkIfSuperBon(this.Main.BonManager.currentCustomerId, code, null)).then(function (superBonId, Name) {

        if (superBonId) {
            var shortcut = superBonId.substring(0, 2);
            superBonId = superBonId.slice(3, superBonId.length);

            $.when(Trans.getSuperBonRebate(superBonId)).then(function (rebForSuperBon) {
                BM.overridePriv = true;
                switch (shortcut) {
                case 'RP':
                case 'SB': // Rebate in Percent
                    $.when(BM.grantRebPercent(rebForSuperBon, superBonId, Name)).done(function () {
                        $.when(BM.updateInstantRebate()).then(function () {
                            return;
                        });
                    });
                    break;
                case 'AR':
                case 'PR': //absolute Rebate -> in EUR
                    $.when(BM.grantRebAbsolute(rebForSuperBon, false, superBonId, Name)).then(function () {
                        $.when(BM.updateInstantRebate()).then(function () {
                            return;
                        });
                    });
                    break;
                case 'TR': //Rebate in percent from Total-> in Proz
                    $.when(BM.grantRebPercentFromTotal(rebForSuperBon, superBonId, Name)).done(function () {
                      //  $.when(BM.updateInstantRebate()).then(function () {
                            return;
                       // });
                    });
                    break;
                case 'TA': //absolute Rebate from Total -> in EUR
                    $.when(BM.grantRebAbsoluteFromTotal(rebForSuperBon, false, superBonId, Name)).then(function () {
                       // $.when(BM.updateInstantRebate()).then(function () {
                            return;
                       // });
                    });
                    break;
                default:
                    console.log('Default shortcut');
                }
                return;
                /*  if (pr) {
                $.when(BM.grantRebAbsolute(rebForSuperBon, false, superBonId, Name)).then(function () {
                $.when(BM.updateInstantRebate()).then(function () {
                return;
                });
                });
                } else {
                $.when(BM.grantRebPercent(rebForSuperBon, superBonId, Name)).done(function () {
                BM.updateInstantRebate();
                });
                }*/
            });

        }

        /*  if (superBonId) {
        var pr = false;
        if (superBonId.startsWith("PR:")) {
        superBonId = superBonId.slice(3, superBonId.length);
        pr = true;
        }
        $.when(Trans.getSuperBonRebate(superBonId)).then(function (rebForSuperBon) {
        BM.overridePriv = true;
        if (pr) {
        $.when(BM.grantRebAbsolute(rebForSuperBon, false, superBonId, Name)).then(function () {
        $.when(BM.updateInstantRebate()).then(function () {
        return;
        });
        });
        } else {
        $.when(BM.grantRebPercent(rebForSuperBon, superBonId, Name)).done(function () {
        BM.updateInstantRebate();
        });
        }
        });
        return;
        } else {
        // end super bons
        /*  $.when(Trans.checkIfRebate(code)).then(function(val) {
        BM.isProductRebate[BM.currentBon.length] = false;
        if (!val) {
        EANManagerClass.getProductFromEANCode(code);
        BM.isProductRebate[BM.currentBon.length] = true;
        } else {
        BM.activeRebatesFromBarcode.push(code);
        }

        BM.updateInstantRebate();
        BM.redrawAll();
        });*/
        //}
    });
}

CEANManager.prototype.showNotFound = function (mode) {
    // Die Bedingung war "!barcodeRequested || (barcodeRequested && eigene
    // Scanner-Sitzung)". Ohne Funkscanner (entfallen am 26.8.2026) war
    // barcodeRequested immer falsch, der erste Teil also immer wahr - die
    // Meldung erschien stets. Genau das bleibt.
    var text = POS.lang.getText("MESSAGES", mode + "_NOT_FOUND");
    POS.message.show(text, "warning", "OK");
}

export { CEANManager };
